<template>
  <h4 class="text-center" v-text="authMsg" />
</template>

<script>
import { getProjectName } from '@/helpers/projectName'
import SiteDetectionMixin from '@/helpers/siteDetectionMixin'

export default {
  name: 'LkHomeIndex',
  mixins: [SiteDetectionMixin],
  computed: {
    authMsg() {
      if (this.isSod || this.isSoop) {
        return 'Для начала работы в системе и отображения всех доступных публикаций, пожалуйста, выполните авторизацию, нажав соответствующую иконку в правом верхнем углу.'
      }
      return `Для работы в системе ${getProjectName()} и отображения публикаций разделов, пожалуйста, выполните авторизацию, нажав соответствующую иконку в правом верхнем углу.`
    },
  },
}
</script>
